
gsap.registerPlugin(ScrollTrigger);


// iOS でスクロール位置のズレ防止
ScrollTrigger.config({
  autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
});

// iOS スムーズスクロール対応
ScrollTrigger.normalizeScroll(true)


let resizeTimer
// リサイズ時の処理
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    ScrollTrigger.refresh();
  }, 250)
})

// 画面の向き変更時
window.addEventListener('orientationchange', () => {
  setTimeout(() => {
    ScrollTrigger.refresh()
  }, 100)
})



const fixedButtons= [
    {element: document.getElementById("sticky-logo"), start: "top-=20px top"},
    {element: document.getElementById("container-apply-animation-button"), start: "bottom bottom-=150px"}, // 暫定値
]

fixedButtons.forEach(el=>{

    ScrollTrigger.create({
        trigger: el.element,
        start: el.start,
        onEnter: () => el.element.classList.add("scrolled"),
        onLeaveBack: () => el.element.classList.remove("scrolled"),
    })
})


const fadeInElements=[
    {
        trigger: "#bubble-bg",
        childrens: [
                {
                    elementName: "#brand-message",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0, 
                    isMoveToUp: false
                },
                {
                    elementName: ".bubble-1",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-2",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-3",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-4",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-5",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
        ]
    },
    {
        trigger: "#all-in-one-bg",
        childrens: [
                {
                    elementName: ".section-title",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0, 
                    isMoveToUp: false
                },
                {
                    elementName: ".box",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0.5, 
                    isMoveToUp: false
                },
        ]
    },
    {
        trigger: "#scene",
        childrens: [
                {
                    elementName: ".section-title",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0, 
                    isMoveToUp: false
                },
                {
                    elementName: ".scene-1 .content-text",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0.8, 
                    isMoveToUp: false
                },
                {
                    elementName: ".scene-1 .content-img",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0, 
                    isMoveToUp: true
                },
                {
                    elementName: ".scene-2 .content-text",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0.8, 
                    isMoveToUp: false
                },
                {
                    elementName: ".scene-2 .content-img",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0, 
                    isMoveToUp: true
                },
        ]
    },
    {
        trigger: "#impression",
        childrens: [
                {
                    elementName: ".section-title",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0, 
                    isMoveToUp: false
                },
                {
                    elementName: ".box-product",
                    fadeInClass: "fade-in",
                    fadeInDelay: 0.8, 
                    isMoveToUp: false
                },
                {
                    elementName: ".bubble-1 .bg",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-1 .box-content",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-2 .bg",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-2 .box-content",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-3 .bg",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0.5, 
                    isMoveToUp: true
                },
                {
                    elementName: ".bubble-3 .box-content",
                    fadeInClass: "fade-in-bubble",
                    fadeInDelay: 0, 
                    isMoveToUp: true
                },
        ]
    },
]

fadeInElements.forEach(config=> initScrollAnimation2(config))


// 水面波紋
createCanvasWavyCircle({
    containerId: '#wavy-animation-container', 
    color: "#18A2E0", 
    sizes:[
        { size: 90, deviceWidth: 0 },
        { size: 120, deviceWidth: 376 },
        { size: 150, deviceWidth: 1024 },
    ]
}
);



/**
 * ランダムな位置に波紋を発生させる関数
 * @param {number} interval - 波紋を発生させる間隔（ミリ秒）
 * @param {number} count - 同時に発生させる波紋の数
 */
function createRandomRipples(interval, count = 3) {
    setInterval(() => {
        const $el = $('#all-in-one-bg');
        const width = $el.outerWidth();
        const height = $el.outerHeight();

        if (width && height) {
            for (let i = 0; i < count; i++) {
                setTimeout(() => {
                    // ランダムな位置を生成
                    const x = Math.random() * width;
                    const y = Math.random() * height;
                    const radius = 30 + Math.random() * 30; // 30-60のランダムな半径
                    const strength = 0.08 + Math.random() * 0.06; // 0.08-0.14のランダムな強度

                    $el.ripples('drop', x, y, radius, strength);
                }, i * 300); // 各波紋を300msずつ遅延
            }
        }
    }, interval);
}

window.addEventListener('load', () => {

  // ページ読み込み完了後全ScrollTriggerを再計算
  ScrollTrigger.refresh()

  // DOM読み込み後に初期化
  const $rippleElement = $('#all-in-one-bg');

  if ($rippleElement.length > 0) {
    try {
      $rippleElement.ripples({
        resolution: 512,    // 解像度
        dropRadius: 180,    // 波紋の半径
        perturbance: 0.8,   // 波の強さ（光の反射強度)
        interactive: true
      });

      // ランダムな波紋を発生
      createRandomRipples(1500, 8);
    } catch (error) {
      console.error('Ripples initialization failed:', error);
    }
  } else {
    console.warn('Element #all-in-one-bg not found for ripples');
  }
})